import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { userVerificationProcessesBackend } from './user-verification-processes.backend';
import { UserVerificationProcessesEffect } from './user-verification-processes.effect';
import { userVerificationProcessesReducer } from './user-verification-processes.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'userVerificationProcesses',
      userVerificationProcessesReducer,
    ),
    BackendModule.forFeature(
      'userVerificationProcesses',
      userVerificationProcessesBackend,
    ),
    EffectsModule.forFeature([UserVerificationProcessesEffect]),
  ],
})
export class DatastoreUserVerificationProcessesModule {}
